export default __webpack_public_path__ + "static/SunExpress_Pressemeldung_1_1_en-97b16e1d91858dc3278f1ba13fd6b798.png";